import { TextInput, Text, Group, Box, ColorPicker, Button } from '@mantine/core';

import { Fields, useFunnelForm } from '../../hooks/useEditFunnelForm';

type Props = {
  isLoading: boolean;
  onSubmit: (params: Fields) => void;
  initialValues?: Fields;
};

export const FunnelForm = ({ isLoading, onSubmit, initialValues }: Props) => {
  const form = useFunnelForm({ initialValues });

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Text mt="sm" mb="xs" size="sm">
        Name
      </Text>
      <TextInput
        required
        placeholder="Funnel name"
        value={form.values.name}
        onChange={(event) => form.setFieldValue('name', event.currentTarget.value)}
        mb="xl"
      />
      <Text size="sm">Color</Text>
      <Group>
        <Box
          sx={{
            width: 20,
            height: 20,
            borderRadius: 100,
            marginLeft: 6,
            backgroundColor: form.values.color || 'rgba(0,0,0,0.05)',
          }}
        />
        <ColorPicker
          styles={{ swatches: { margin: 5 } }}
          size="md"
          withPicker={false}
          format="hex"
          swatches={['#a64d79', '#fd6a86', '#fd986a', '#fde16a', '#cffd6a', '#6a86fd', '#cfe2f3']}
          value={form.values.color}
          onChange={(color) => form.setFieldValue('color', color)}
        />
      </Group>
      <Group justify="right">
        <Button loading={isLoading} type="submit">
          {initialValues ? 'Edit' : 'Add'}
        </Button>
      </Group>
    </form>
  );
};
